<template>
  <div id="FontStore" class="font-store">
    <section>
      <h1 class="main-title">가비아 무료 글꼴을<br> 자유롭게 사용하세요.</h1>
      <div class="font-download-buttons">
        <div class="font-download-circle" v-for="(circle, index) in extraCircle" :key="index" :style="{top: circle.top, left: circle.left}">
          <svg width="222px" height="222px">
            <circle cx="111" cy="111" r="110" stroke="#000" stroke-width="1" fill="none"></circle>
          </svg>
        </div>
        <div class="font-download-item" v-for="font in fontList" :key="font.name"
             :style="{top: font.top, left: font.left}">
          <a :href="`https://static.gabia.com/fonts/project/fonts${font.download_link}`" >
            <img class="font-image" :src="`https://static.gabia.com/fonts/project/image/font_download/${font.name}_img.png`" :alt="font.name">
            <img class="font-solid" :src="`https://static.gabia.com/fonts/project/image/font_download/${font.name}_s.svg`" :alt="font.name">
          </a>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';

export default {
  name: 'FontStore',
  components: { Footer },
  data() {
    return {
      slideKeyFrame: 5000,
      fontList: [
        {
          name: 'solmee', download_link: '/Download-font/GabiaSolmee.zip', top: '68%', left: '64%', rotate: '360deg',
        },
        {
          name: 'bombaram', download_link: '/Download-font/GabiaBombaram.zip', top: '20%', left: '83%', rotate: '0deg',
        },
        {
          name: 'napjakBlock', download_link: '/Download-font/GabiaNapjakBlock.zip', top: '80%', left: '80%', rotate: '0deg',
        },
        {
          name: 'maeumgyeol', download_link: '/Download-font/GabiaMaeumgyeol.zip', top: '43%', left: '4%', rotate: '20deg',
        },
        {
          name: 'cheongyeon', download_link: '/Download-font/GabiaCheongyeon.zip', top: '74%', left: '24%', rotate: '340deg',
        },
        {
          name: 'heuldot', download_link: '/Download-font/GabiaHeuldot.zip', top: '17%', left: '10%', rotate: '340deg',
        },
        {
          name: 'ondam', download_link: '/Download-font/GabiaOndam.zip', top: '10%', left: '53%', rotate: '20deg',
        },
        {
          name: 'gosran', download_link: '/Download-font/GabiaGosran.zip', top: '17%', left: '20%', rotate: '360deg',
        },
        {
          name: 'null', download_link: '/Download-font/GabiaNull.zip', top: '8%', left: '29%', rotate: '340deg',
        },
      ],
      extraCircle: [
        { top: '25%', left: '85%' },
        { top: '46%', left: '6%' },
        { top: '67%', left: '80%' },
        { top: '18%', left: '53%' },
      ],
    };
  },
  mounted() {
    document.body.style.height = 'auto';
    const fonts = document.querySelectorAll('.font-download-item');
    fonts.forEach((item, i) => {
      setTimeout(() => {
        item.style.transform = `scale(1) rotate(${this.fontList[i].rotate})`;
      }, 100 * i);
    });
    const circle = document.querySelectorAll('.font-download-circle');
    circle.forEach((item) => {
      setTimeout(() => {
        item.style.opacity = '1';
      }, 600);
    });
  },
};

</script>

<style lang="scss" scoped>
#FontStore {
  section {
    height: calc(100vH - 233px);
    display: flex;
    justify-content: center;
    align-items: center;
    .main-title {
      text-align: center;
    }
    .font-download-item {
      width: 220px;
      height: 220px;
      position: absolute;
      transition: transform 1000ms ease;
      transform: scale(0);
      transition-delay: 250ms;
      border-radius: 50%;
      overflow: hidden;
      &:last-child {
        border-radius: 0;
      }
      a {
        width: 100%;
        height: 100%;
      }
      img {
        position: absolute;
        width: 100%;
        display: block;
      }
      img.font-solid {
        &:hover {
          opacity: 0;
        }
      }
    }
    .font-download-circle {
      width: 220px;
      height: 220px;
      position: absolute;
      transition-delay: 400ms;
      opacity: 0;
    }
  }

}
</style>
